
// `x-charts-vendor/d3-array` (CommonJS)
// See upstream license: https://github.com/d3/d3-array/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-array`
module.exports = require("../lib-vendor/d3-array/src/index.js");
